<template lang="pug">
  .users-list
    .container-fluid
      .container
        .row.pt-3.pb-1
          .col
            h3 {{ $t('users_list.account_list') }} ({{ $t('users_list.top') }})
            h1 {{ $t('users_list.users_list') }}
          .col.text-right.pt-2
            b-button.btn.btn-primary.mr-3.px-4.py-0(
              @click='addUser'
            )
              i.fas.fa-plus.mr-2
                span.ml-2 {{ $t('users_list.add_user') }}
            button(
              class="btn btn-outline-primary px-4 py-0"
              @click="downloadUserList"
            ) {{ $t('users_list.download_user_list') }}
    .container-fluid.table-container
      .table-header-background-wrapper
        .table-header-background
      .container
        .row.pt-3
          users-table(
            :key='uniqKey'
            @selectUser='setSelectedUser'
          )

    add-edit-admin-user(
      :user='user',
      :phones='phones'
      @reset='resetModal'
      @addedUser='refreshTable'
      @editedUser='refreshTable'
    )
</template>

<script>
  import { api } from '@/api.js'
  import { clone, cloneDeep } from 'lodash'
  import UsersTable from '@/pages/Admin/User/List/users-table'
  import downloadXlsx from '@/mixins/download-xlsx'
  import AddEditAdminUser from '@/pages/Admin/User/Add/add-edit-admin-user.vue'
  import addEditUserMixin from '@/mixins/add-edit-user'

  export default {
    components: {
      UsersTable,
      AddEditAdminUser
    },

    mixins: [
      addEditUserMixin,
      downloadXlsx
    ],

    data() {
      return {
        user: {},
        phones: [],
        uniqKey: 0
      }
    },

    computed: {
      downloadUserListUrl() {
        return '/users/download'
      }
    },

    methods: {
      downloadUserList() {
        api.post(this.downloadUserListUrl, {}, { responseType: 'arraybuffer' }).then(({ data, headers }) => {
          this.downloadXlsx(data, 'users.xlsx', headers['content-type'])
        }).catch(() => {
          this.$bvToast.show('error-loading')
        })
      },
      
      refreshTable() {
        this.uniqKey ++
      },

      setSelectedUser(user) {
        this.user = clone(user)
        this.phones = cloneDeep(user.phones)
        this.$bvModal.show('modal-add-admin-user')
      },

      resetModal() {
        this.setDefaultData()
      },

      addUser() {
        this.setDefaultData()

        this.$bvModal.show('modal-add-admin-user')
      },

      setDefaultData() {
        this.user = {
          email: '',
          first_name: '',
          last_name: '',
          organization_id: '',
          department: '',
          read_only: true
        }
        this.phones = [this.defaultPhone()]
      }
    }
  }
</script>

<style lang="scss" scoped>
  .users-list {
    background-color: #fff;
  }

  h1 {
    color: #3d4a57;
    font-size: 30px;
    font-weight: 700;
  }

  h3 {
    color: #7c91a7;
    font-size: 11px;
    font-weight: 700;
  }

  .btn-primary,
  .btn-primary:hover,
  .btn-primary:focus,
  .btn-primary:active {
    background-image: linear-gradient(90deg, rgba(24, 172, 235, 0.98) 0%, #18a4eb 100%);
    border-color: transparent !important;
    border-radius: 4px;
    box-shadow: none;
    font-size: 14px;
    font-weight: 500;
    height: 40px;
    line-height: 38px;
  }

  .btn-outline-primary,
  .btn-outline-primary:hover,
  .btn-outline-primary:focus,
  .btn-outline-primary:active {
    background: transparent;
    border: 1px solid rgba(0, 156, 234, 0.3);
    border-radius: 4px;
    color: #009cea;
    font-size: 14px;
    height: 40px;
    line-height: 38px;
  }

  .table-container {
    background: #fcfdfe;
    position: relative;

    .table-header-background-wrapper {
      height: 67px;
      margin: 0 -15px;
      overflow: hidden;
      position: absolute;
      width: 100%;
    }

    .table-header-background {
      background: #fff;
      box-shadow: 0 2px 16px 0 rgba(176, 186, 197, 0.2);
      height: 55px;
    }
  }
</style>
